import { useState } from 'react';

import { Button } from '@material-ui/core';

import { RiPulseLine } from '@remixicon/react';

import type { SaveToPulseInput } from '../../types';
import {
  SaveToPulseDialog,
  type SaveToPulseSuccess,
} from '../SaveToPulseDialog';

type SaveToPulseButtonProps = {
  input: SaveToPulseInput;
  onSuccess?: (info: SaveToPulseSuccess) => void;
};

export const SaveToPulseButton = ({
  input,
  onSuccess,
}: SaveToPulseButtonProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={<RiPulseLine size={16} />}
        onClick={() => setDialogOpen(true)}
       data-track-source-anchor="ff83358ded">
        Add to pulse
      </Button>
      {dialogOpen && (
        <SaveToPulseDialog
          isOpen={dialogOpen}
          onOpenChange={setDialogOpen}
          input={input}
          onSuccess={onSuccess}
         data-track-source-anchor="e5f0f79432;save-to-pulse-button-save-to-pulse-dialog"/>
      )}
    </>
  );
};
